import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

// Create a new purchase
export const createPurchase = async (purchaseData) => {
  try {
    const response = await axios.post(`${API_URL}/boncommandeachat/save`, purchaseData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating purchase:", error);
    throw error;
  }
};

// Update an existing purchase
export const updatePurchase = async (purchaseData, purchaseId) => {
  try {
    const response = await axios.put(`${API_URL}/boncommandeachat/save/${purchaseId}`, purchaseData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating purchase:", error);
    throw error;
  }
};

// Fetch a purchase by ID
export const fetchPurchaseById = async (purchaseId) => {
  try {
    const response = await axios.get(`${API_URL}/boncommandeachat/byid/${purchaseId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    console.log('this is the response from the purchase', response.data); 
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase:", error);
    throw error;
  }
};

// Fetch all purchases with optional pagination, search and date filtering
export const fetchPurchases = async (params = {}) => {
  try {
    // Extract parameters with defaults
    const { page = 1, limit = 10, search = '', startDate = '', endDate = '' } = params;
    
    // Build params object starting with required pagination parameters
    const queryParams = { 
      PageNumber: page, 
      Size: limit
    };
    
    // Only add search and date parameters if they're not empty
    if (search) queryParams.searchTerms = search;
    if (startDate) queryParams.DateDebut = startDate;
    if (endDate) queryParams.DateFin = endDate;
    
    const response = await axios.get(`${API_URL}/boncommandeachat/pagination`, {
      params: queryParams,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchases:", error);
    throw error;
  }
};

// Delete a purchase
export const deletePurchase = async (purchaseId) => {
  try {
    const response = await axios.delete(`${API_URL}/boncommandeachat/${purchaseId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting purchase:", error);
    throw error;
  }
};

// Generate a new purchase reference
export const generatePurchaseReference = async () => {
  try {
    const response = await axios.get(`${API_URL}/Purchase/generate-reference`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error generating purchase reference:", error);
    throw error;
  }
};

